import { getStoredAcquisitionParams } from "./acquisition";

const trimTrailingSlash = (value: string) => value.replace(/\/$/, "");

export const PRODUCT_ORIGIN = trimTrailingSlash(
  process.env.REACT_APP_PRODUCT_ORIGIN || "https://app.runmark.app"
);

export const ADMIN_ORIGIN = trimTrailingSlash(
  process.env.REACT_APP_ADMIN_ORIGIN || "https://admin.runmark.app"
);

const UTM_FIELDS = [
  ["utm_source", "source"],
  ["utm_medium", "medium"],
  ["utm_campaign", "campaign"],
  ["utm_term", "term"],
  ["utm_content", "content"],
] as const;

export function productUrl(path: string): string {
  const url = new URL(path.startsWith("/") ? path : `/${path}`, `${PRODUCT_ORIGIN}/`);

  if (typeof window === "undefined") {
    return url.toString();
  }

  const currentParams = new URLSearchParams(window.location.search);
  const storedAcquisition = getStoredAcquisitionParams();

  UTM_FIELDS.forEach(([queryKey, storageKey]) => {
    if (url.searchParams.has(queryKey)) {
      return;
    }

    const value = currentParams.get(queryKey) || storedAcquisition?.[storageKey];
    if (value) {
      url.searchParams.set(queryKey, value);
    }
  });

  return url.toString();
}

export function adminUrl(path: string): string {
  return `${ADMIN_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}
